import { __assign } from "tslib";
import * as Rules from './Rules';
import { ensureTypeInfo } from '../Model/NeoTypeInfo';
import NeoStrings from '../Localisation/NeoStrings';
function addRuleToType(type, propertyName, rule) {
    ensureTypeInfo(type.constructor).neo.addAttributeRule(propertyName, rule);
}
export function Required(errorTextOrOptions) {
    return function (type, propertyKey) {
        var options = { errorText: NeoStrings.validation.rules.required, allowZero: false };
        if (errorTextOrOptions !== undefined) {
            if (typeof errorTextOrOptions === "string") {
                options.errorText = errorTextOrOptions;
            }
            else {
                options = __assign(__assign({}, options), errorTextOrOptions);
            }
        }
        var requiredRule = new Rules.RequiredRule(options.errorText, options.allowZero);
        addRuleToType(type, propertyKey, requiredRule);
    };
}
export function EmailAddress(errorText) {
    return function (type, propertyKey) {
        var emailAddressRule = new Rules.EmailAddressRule(errorText !== null && errorText !== void 0 ? errorText : NeoStrings.validation.rules.emailAddress);
        addRuleToType(type, propertyKey, emailAddressRule);
    };
}
export function RegExp(expression, errorText) {
    return function (type, propertyKey) {
        var regExpRule = new Rules.RegExpRule(expression, errorText !== null && errorText !== void 0 ? errorText : NeoStrings.validation.rules.regExp);
        addRuleToType(type, propertyKey, regExpRule);
    };
}
export function StringLength(minOrMaxLength, arg2, errorText) {
    return function (type, propertyKey) {
        var minLength;
        var maxLength = minOrMaxLength;
        if (arg2) {
            if (typeof arg2 === "string") {
                errorText = arg2;
            }
            else {
                minLength = minOrMaxLength;
                maxLength = arg2;
            }
        }
        var minLengthRule = new Rules.StringLengthRule(maxLength, minLength, errorText);
        addRuleToType(type, propertyKey, minLengthRule);
    };
}
